import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-nbp-modal-imagem',
  encapsulation: ViewEncapsulation.None,
  styles: [`
    .nbp-modal-imagem-class .modal-dialog {
      max-width: 650px;
    }
  `],
  template: `
    <div class="modal-header">
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <img src="{{caminhoImagem}}" class="img-fluid d-block" alt="Preço da Hora"/>
    </div>`
})
export class NbpModalImagemComponent {

  @Input() caminhoImagem: string;
  constructor(public activeModal: NgbActiveModal) {}

}



// WEBPACK FOOTER //
// ./src/app/shared/modal/nbp-modal-imagem.component.ts